module.exports = __webpack_public_path__ + "static/media/Nuevo-Logo-negativo.7ea56b82.png";